export enum TableIdType {
  messageTable = 'messageTable',
  sessionTable = 'sessionTable',
  userTable = 'userTable',
  contactsTable = 'contactsTable',
  encryptionTable = 'encryptionTable',
  groupTable = 'groupTable',
  groupSetTable = 'groupSetTable',
  groupMemberTable = 'groupMemberTable',
  readStateTable = 'readStateTable',
}

export interface WorkerMessage {
  id: string;
  dbName: string;
  tableId: keyof typeof TableIdType;
  type: keyof typeof ActionType;
  tableName?: string;
  params?: any;
}

export interface WorkerResponse {
  id: string;
  success: boolean;
  data?: any;
  error?: any;
}

export enum ActionType {
  init = 'init',
  close = 'close',
  // MessageTableManager
  addMessages = 'addMessages',
  queryMessages = 'queryMessages',
  queryMessagesWithPagination = 'queryMessagesWithPagination',
  queryUnreadMessageCount = 'queryUnreadMessageCount',
  queryMessageById = 'queryMessageById',
  // queryMessagesById = 'queryMessagesById',
  queryMessageByMsgId = 'queryMessageByMsgId',
  queryMessageByCliMsgId = 'queryMessageByCliMsgId',
  queryLastMessage = 'queryLastMessage',
  updateMessages = 'updateMessages',
  updateMessagesById = 'updateMessagesById',
  updateMessagesByMsgId = 'updateMessagesByMsgId',
  updateMessagesByCliMsgId = 'updateMessagesByCliMsgId',
  deleteMessagesData = 'deleteMessagesData',
  deleteExpiredData = 'deleteExpiredData',
  deleteMessageTable = 'deleteMessageTable',

  // SessionTableManager
  addSessions = 'addSessions',
  querySessions = 'querySessions',
  querySessionById = 'querySessionById',
  querySessionByChatId = 'querySessionByChatId',
  updateSessions = 'updateSessions',
  deleteSessions = 'deleteSessions',

  // User
  setUserData = 'setUserData',
  //setUserDatas = 'setUserDatas',
  getUserData = 'getUserData',
  getUserDatas = 'getUserDatas',
  removeUserData = 'removeUserData',
  deleteUserdataTable = 'deleteUserdataTable',
  deleteAllExpiredData = 'deleteAllExpiredData',

  // EncryptionTableManager
  addEncryption = 'addEncryption',
  queryEncryptions = 'queryEncryptions',
  deleteEncryptions = 'deleteEncryptions',

  // ContactsTableManager
  addContacts = 'addContacts',
  queryContacts = 'queryContacts',
  queryContactById = 'queryContactById',
  queryContactByUserId = 'queryContactByUserId',
  updateContacts = 'updateContacts',
  deleteContacts = 'deleteContacts',
  deleteContactsByUserid = 'deleteContactsByUserid',
  clearContacts = 'clearContacts',

  // GroupTableManager
  addGroups = 'addGroups',
  queryGroups = 'queryGroups',
  queryGroupById = 'queryGroupById',
  queryGroupByGroupId = 'queryGroupByGroupId',
  updateGroups = 'updateGroups',
  deleteGroups = 'deleteGroups',

  // GroupSetTableManager
  setGroupSetData = 'setGroupSetData',
  // setGroupSetDatas = 'setGroupSetDatas',
  getGroupSetData = 'getGroupSetData',
  getGroupSetDatas = 'getGroupSetDatas',
  deleteGroupSetData = 'deleteGroupSetData',
  deleteGroupSetTable = 'deleteGroupSetTable',

  // GroupMemberTableManager
  addGroupMembers = 'addGroupMembers',
  queryGroupMembers = 'queryGroupMembers',
  queryGroupMemberById = 'queryGroupMemberById',
  queryGroupMemberByUserId = 'queryGroupMemberByUserId',
  updateGroupMembers = 'updateGroupMembers',
  deleteGroupMembers = 'deleteGroupMembers',
  deleteGroupMembersByUserIds = 'deleteGroupMembersByUserIds',
  // ReadStateTableManager
  addReadStates = 'addReadStates',
  queryReadStateById = 'queryReadStateById',
  queryReadStateByMsgId = 'queryReadStateByMsgId',
  updateReadStates = 'updateReadStates',
  deleteReadStates = 'deleteReadStates',
  addOrUpdateReadstates = 'addOrUpdateReadstates',
}
